import { useCallback, useState } from "react";
import { Col, Container, Dropdown, Row, Tab } from "react-bootstrap";
import {
  CommonSelect,
  CstmPagination
} from "../../../components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, successMessageToast, userFullName } from "helpers/common";
import {
  EDIT_NOTES,
  MULTIDISCIPLINARY_SERVICES_DETAIL,
} from "config/paths";
import { useDispatch, useSelector } from "react-redux";
import { notificationsFilter } from "store/slices/filter";
import { debounce } from "lodash";
import { usePersistentState } from "hooks/usePersistentState";
import { useGetNotificationsFilterTypesQuery, useGetNotificationsQuery, useMarkAllNotificationReadMutation, useMarkSingleNotificationReadMutation } from "store/services/notifications";
import NotificationTableLayout from "components/TableLayoutV2/NotificationTable";
import { ThreeDotsMenuIcon } from "Assets/icons/v2";
import { generatePath, useNavigate } from "react-router-dom";
import userImg from 'Assets/images/user.png';

const Notifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = usePersistentState("notifications:page", 1);
  const [pageSize, setPageSize] = useState(10);
  const filter = useSelector(state => state?.filter?.notificationsFilter);

  const [markSingleNotificationRead, { isLoading: isMarkSingleNotificationReadLoading }] = useMarkSingleNotificationReadMutation();
  const [markAllNotificationsRead, { isLoading: isMarkAllNotificationsReadLoading }] = useMarkAllNotificationReadMutation()
  const { data, isLoading, isError, isFetching } = useGetNotificationsQuery({ page: currentPage, limit: pageSize, ...filter });
  const notifcations = data?.records;
  const totalRecords = data?.total || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const markReadDisabled = notifcations?.some((x) => x?.is_read == false);
  const { data: filterType, isFetching: filterTypesLoading } = useGetNotificationsFilterTypesQuery()

  console.log('currentPage', currentPage)

  const handleCreateUrl = async (item) => {
    const clientType = item?.module == "home_education" ? "home-education" : item?.module

    if (!item?.is_read) {
      try {
        await markSingleNotificationRead({ id: item?.id }).unwrap();
      } catch (err) {
        console.error("Error marking notification as read", err);
      }
    }

    if (item?.type == 'client_assigned' || item?.type == 'client_discharged' || item?.type == 'client_note_added') {
      navigate(`/client/${clientType}/detail/${item?.client?.id}`)
    }
    else if (item?.type == "mdt_assigned") {
      navigate(generatePath(MULTIDISCIPLINARY_SERVICES_DETAIL, { id: item?.client?.id }))
    }
    else if (item?.type_label == "Note") {
      navigate(generatePath(EDIT_NOTES, { id: item?.metadata?.note_id }))
    }
    else {
    }
  }

  const column = [
    // {
    //   head: <div onClick={() => dispatch(notificationsFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
    //   accessor: "is_favorite",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
    //   ),
    // },
    {
      head: (
        <>
          <div className="d-flex align-items-center">DATE</div>
        </>
      ),
      accessor: "createdAt",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <div className="d-flex align-itmes-center">
          <h6 className="m-0 fw-sbold">{dateFormat(item?.createdAt, "MMM DD hh:mm A")}</h6>
        </div>
      ),
    },
    // {
    //   // head: (
    //   //   <>
    //   //     <div className="d-flex align-items-center">Date</div>
    //   //   </>
    //   // ),
    //   accessor: "createdAt",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <div className="d-flex align-itmes-center">
    //       <h6 className="m-0 fw-sbold">{dateFormat(item?.createdAt, "hh:mm A")}</h6>
    //     </div>
    //   ),
    // },
    {
      head: "BY",
      accessor: "firstname",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-2">
          <img
            src={item?.actor?.therapist_detail?.profile_picture || userImg}
            alt="profile"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <h6 className="m-0 fw-sbold">{userFullName(item?.actor)}</h6>
        </div>
      ),
    },
    {
      head: "NOTIFICATION MESSAGE",
      accessor: "notificaiton",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.message}</h6>
      ),
    },
    {
      head: "LINK",
      accessor: "grade",
      component: (item, ind) => <h6 onClick={() => handleCreateUrl(item)} style={{ textDecoration: "underline", cursor: "pointer", color: "#315D99" }} className="m-0 fw-sbold">{item?.link_url || "File Link"}</h6>,
    },
    {
      head:
        <div className="reports-v2 my-3 gap-2 gap-lg-0 d-flex justify-content-end classroom-conslutation">
          <div className="d-flex align-items-center gap-3">
            <label className="discharge-screen-label mb-0">Type</label>
            <CommonSelect
              placeholder={"Select"}
              option={filterType?.types?.map((item) => ({ label: item, value: item }))}
              onChange={(e) => handleFilterChange("type")(e)}
              value={filter?.type}
              // onInputChange={(val) => handleSearch(val)}
              isFilterV2
              isLoading={filterTypesLoading}
              isClearable
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: "100%", // ✅ Ensures the whole Select container is full width
                }),
              }}
            // isLoading={schoolsLoading}
            />
          </div>
        </div>
      ,
      accessor: "grade",
      component: (item, ind) => <h6 className="m-0 fw-sbold">{item?.type_label || "--"}</h6>,
    },
    {
      // head: "Action",
      accessor: "",
      isComponent: true,
      component: (item, index) => (!item?.is_read &&
        <Dropdown
          onClick={(e) => e.stopPropagation()}
        >
          <Dropdown.Toggle
            variant="transparent"
            className="p-0 border-0 text-dark w-100"
            id="dropdown-basic"
          >
            <ThreeDotsMenuIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
            <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
              <h5 onClick={(e) => {
                e.stopPropagation();
                handleMarkRead("single", item?.id);
                // navigate(TASK_PLAN_EDIT.replace(":id", item.id));
              }} className="cursor-pointer proxima">
                Mark as read
              </h5>

              {/* <h5 onClick={(e) => {
                                      e.stopPropagation();
                                      console.log(item)
                                      setCurrentEntry(item)
                                      setShowModal(true)
                                  }} className="cursor-pointer proxima mb-0">
                                      Delete
                                  </h5> */}

            </ul>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
  ];

  const handleMarkRead = async (type, id) => {
    try {
      const result = type == 'single' ? await markSingleNotificationRead({ id }).unwrap() : await markAllNotificationsRead().unwrap();
      successMessageToast(result?.message);
    } catch (err) {
      console.error("Error marking notification as read", err);
    }
  }

  const handleFilterChange = (key) => (value) => {
    dispatch(notificationsFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  // const handleGetRowColor = (item) => {
  //   console.log('item ', item)
  //   if (item?.status == "discharged") {
  //     return "rowYellow";
  //   }
  //   else if (item?.status == "inactive") {
  //     return "rowGray";
  //   }
  // }

  const handleSearchChange = useCallback(debounce((value) => {

    handleFilterChange("search")(value);

  }, 500), [handleFilterChange, 500]);

  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  return (
    <>
      <section className="client position-relative py-4">
        <Container fluid>
          {isLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> : <Row>
            <div className="d-flex justify-content-between align-items-center">
              <div className="left classroom-conslutation">
                <h6 className="m-0 fw-bold main-head themeBlue">Notifications</h6>
              </div>
              <button
                onClick={() => { handleMarkRead() }}
                type="button"
                disabled={!markReadDisabled || isMarkAllNotificationsReadLoading || isMarkSingleNotificationReadLoading}
                className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
              // disabled={isFetching || submitting || copyReportLoading}
              // isLoading={submitReportLoading || submitting}
              >
                Mark as all read
              </button>
            </div>
            <Col lg="12" className="my-2">
              {/* <TableHeader
                heading={"School Caseload"}
                filter={filter}
                handleFilterChange={handleFilterChange}
                resetFilter={resetFilter}
                searchPlaceholder="Client First, Last Name"
                filterComponent={
                  <>
                    <li className="">
                      <SearchListCheckbox

                        type="radio"
                        inputPlaceholder={"Search Board Name"}
                        title={schoolDivisonsList?.find(x => x.id == filter?.division)?.title || "School Division"}
                        options={schoolDivisonsList?.map((item) => ({
                          label: item?.title,
                          value: item?.id,
                        }))}
                        handleChange={(selected) => {
                          handleFilterChange("division")(selected);
                        }}
                      />
                    </li>
                    <li>
                      <Dropdown onSelect={(selected) => handleFilterChange("school")({ value: selected })}>
                        <Dropdown.Toggle
                          className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                          variant="transparent"
                          id="dropdown-basic"
                        >
                          <div className="d-flex">
                            <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                              {schoolOptions.find(x => x.id == filter?.school?.value)?.name || "Select School"}
                            </div>
                            <span className="icn" style={{ marginRight: "20px" }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                              >
                                <path
                                  d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                          {schoolOptions?.length ? schoolOptions?.map((item, index) => {
                            return <Dropdown.Item eventKey={item?.id}>{item?.name}</Dropdown.Item>
                          }) : <>
                            <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>

                          </>
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                    <li>
                      <Dropdown onSelect={(selected) => handleFilterChange("grade")(selected)}>
                        <Dropdown.Toggle
                          className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                          variant="transparent"
                          id="dropdown-basic"
                        >
                          <div className="d-flex">
                            <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                              {gradeOptions.find(x => x.value == filter?.grade)?.label || "Select Grade"}
                            </div>
                            <span className="icn" style={{ marginRight: "20px" }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                              >
                                <path
                                  d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                          {gradeOptions?.length ? gradeOptions?.map((item, index) => {
                            return <Dropdown.Item key={index} eventKey={item?.value}>{item?.label}</Dropdown.Item>
                          }) :
                            <>
                              <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>
                            </>
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </>
                }
              ></TableHeader> */}

              <div className="table-outer">
                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching) && <LoadingOverlay />}
                    {/* <TableLayout
                      data={notifcations}
                      column={column}
                      url={SCHOOL_CLIENT_DETAIL.replace("/:id", "")}
                    // url={"/manage-team/therapist-profiles/detail/"}
                    /> */}
                    <NotificationTableLayout
                      data={notifcations}
                      column={column}
                      filter={filter}
                      // url={SCHOOL_CLIENT_DETAIL.replace("/:id", "")}
                      handleSort={handleFilterChange("sort")}
                    // handleGetRowColor={handleGetRowColor}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

export default Notifications;
